import React from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Start Icon
const startIcon = new L.Icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/512/684/684908.png",
  iconSize: [10, 10],
  popupAnchor: [0, -28],
});

const Wordmapchart = ({ routeData }) => {
  // Default map center
  const defaultCenter = [50.5, 30.5];
  // Filter valid route points
  const validRoutePoints = routeData?.series?.length
    ? routeData?.series.filter(
        (point) =>
          point.Lat_degree !== undefined && point.Long_degree !== undefined
      )
    : [];
  console.log("validRoutePoints", validRoutePoints);
  return (
    <MapContainer
      center={
        validRoutePoints.length > 0
          ? [validRoutePoints[0].Lat_degree, validRoutePoints[0].Long_degree]
          : defaultCenter
      }
      zoom={3}
      style={{ height: "300px", width: "100%" }}
    >
      {/* Tile Layer */}
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />

      {/* Render Polyline if valid route points exist */}
      {validRoutePoints.length > 1 && (
        <Polyline
          positions={validRoutePoints.map((point) => [
            point.Lat_degree,
            point.Long_degree,
          ])}
          color="#2d6c5c"
          weight={2}
          opacity={0.7}
        />
      )}

      {/* Render Markers if routeData exists, else show a default marker */}
      {validRoutePoints.length > 0 ? (
        validRoutePoints.map((point) => (
          <Marker
            key={point.id}
            position={[point.Lat_degree, point.Long_degree]}
            icon={startIcon}
          >
            <Popup>
              <b>Date:</b> {point.date} <br />
              <b>Latitude:</b> {point.Lat_degree}
              <br />
              <b>Longitude:</b> {point.Long_degree}
            </Popup>
          </Marker>
        ))
      ) : (
        <Marker position={defaultCenter}>
          <Popup>No route data available.</Popup>
        </Marker>
      )}
    </MapContainer>
  );
};

export default Wordmapchart;
